import React from "react"
import { Link } from "react-router-dom"
import { H4, Paragraph } from "../../components/typography/Typography"
import republicDay2026 from '../../assets/jobrefs/republic-day-2026-hero.webp'
import orana from '../../assets/orana.webp'
import chandigarh from '../../assets/strawberryfields.png'


type ProductNavItem = {
  href: string
  title: string
  description: string
  image: string
  alt: string
}

const productNav: ProductNavItem[] = [
  {
    href: "/job-references/republic-day-2026",
    title: "Republic Day 2026",
    description: "Kartavya Path",
    image: republicDay2026,
    alt: "Seating set out on Kartavya Path for Republic Day 2026",
  },
  {
    href: "/job-references/orana-conventions",
    title: "Orana Conventions Center",
    description: "Gurugram",
    image: orana,
    alt: "Orana Conventions Center",
  },
  {
    href: "/job-references/strawberry-fields",
    title: "Strawberry Fields School",
    description: "Chandigarh",
    image: chandigarh,
    alt: "Strawberry Fields School",
  },
]

export const JobRefPanel = ({ onClick }: { onClick: () => void }) => {

  return (
    <div className="flex flex-col gap-4 p-4 lg:flex-row md:justify-between">
      {productNav.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          onClick={onClick}
          className="w-full rounded-xl border border-gray-200 bg-white p-3 transition hover:bg-gray-50"
        >
          <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-start">
            {/* Image */}
            {/* Pin the aspect ratio rather than letting `h-auto` follow each
                source image — the three photos are not all the same shape, so
                auto height made the thumbnails different sizes. */}
            <img
              src={item.image}
              alt={item.alt}
              className="h-40 w-full rounded-lg object-cover md:aspect-[4/3] md:h-auto md:w-56"
            />
            {/* Text */}
            <div className="w-full md:w-48">
              <H4 className="mt-1">{item.title}</H4>
              <Paragraph className="mt-1">{item.description}</Paragraph>
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}
